import React, { useEffect, useState } from "react";
import styles from "./Header.module.css";
import { useNavigate } from "react-router-dom";

const Header = () => {
    const navigate = useNavigate();

    const handleLoguot = () => {
        localStorage.removeItem("token");
        navigate("/");
    };

    return (
        <div className={styles.container}>
            <p className={styles.titleName}>JCONNECT ADMIN</p>
            <button
                className={styles.loguotButton}
                onClick={handleLoguot}>
                <p className={styles.buttonText}>Выйти</p>
            </button>
        </div>
    );
};

export default Header;
